
import { defineComponent } from "vue";

import Header from "@/components/CarouselHeader.vue";
import Stats from "@/components/Stats.vue";

export default defineComponent({
  components: {
    Header,
    Stats,
  },
  data() {
    return {
      bgImg: require("@/assets/img/anesthesiology-banner.png"),
    };
  },
});
